import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseAdvanceGovernmentAllocationEntryProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useAdvanceGovernmentAllocationEntry = ({ id, onSuccess, onError }: UseAdvanceGovernmentAllocationEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['advanceGovernmentAllocationEntry'],
    mutationFn: async () => {
      await privateAxios.put(`/billing/government_allocation_entries/${id}/advance`)
    },
    onSuccess,
    onError,
  })
}

export default useAdvanceGovernmentAllocationEntry
